import routes_workers from "./servicios/workers/routes";
import routes_ari from "./servicios/risk_analysis/routes";

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/inicio',
        component: resolve => require(['./containers/DefaultContainer.vue'], resolve),
        children: [

            {
                path: '',
                component: resolve => require(['./views/home/index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Soluquim - Mejora & Soluciones',
                    permiso: ['inicio'],
                    breadcrumb: [
                        {
                            text: ' Inicio',
                            href: '/',
                        }
                    ]
                }
            },
            {
                path: '/panel-de-control',
                component: resolve => require(['./views/control_panel/Main.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Panel de control',
                    permiso: ['superadmin','modulo-panel-control-graficas'],
                    breadcrumb: ``
                }
            },
            {
                path: '/tickets',
                component: resolve => require(['./views/tickets/Main.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Tickets',
                    permiso: ['modulo-tickets'],
                    breadcrumb: ``
                }
            },
            {
                path: '/tickets/:id/:company_id',
                name: 'tickets-detalle',
                component: resolve => require(['./views/tickets/Detalle.vue'], resolve),
                props: true,
                meta: {
                    autenticado: true,
                    title: 'Tickets',
                    permiso: ['modulo-tickets'],
                    breadcrumb: ``
                }
            },
            {
                path: '/empresas',
                component: resolve => require(['./views/empresa'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Empresa',
                    permiso: ['modulo-empresas'],
                    breadcrumb: '/empresas'
                }
            },
            {
                path: '/empresas/nueva',
                component: resolve => require(['./views/empresa/tabs.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Empresa',
                    permiso: ['crear-empresas'],
                    breadcrumb: '/empresas/nueva'
                }
            },
            {
                path: '/empresas/:id',
                component: resolve => require(['./views/empresa/tabs.vue'], resolve),
                alias: '/my-company/:id',
                meta: {
                    autenticado: true,
                    title: 'Empresa',
                    permiso: ['visualizar-informacion-empresas', 'empresa-ver-generales'],
                    breadcrumb: '/empresas/:id'
                }
            },
            {
                path: '/fabricantes',
                component: resolve => require(['./views/fabricantes/Buscador.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Fabricantes',
                    permiso: ['modulo-fabricantes'],
                    breadcrumb: '/fabricantes'
                }
            },
            {
                path: '/fabricante/:id?',
                component: resolve => require(['./views/fabricantes/Formulario.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Fabricante',
                    permiso: ['editar-fabricantes'],
                    breadcrumb: '/fabricante'
                }
            },
            {
                path: '/providers',
                component: resolve => require(['./views/providers/index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Fabricantes',
                    permiso: ['modulo-fabricantes'],
                    breadcrumb: '/providers'
                }
            },
            {
                path: '/providers/form/:id?',
                component: resolve => require(['./views/providers/form.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Fabricante',
                    permiso: ['editar-fabricantes'],
                    breadcrumb: '/providers'
                }
            },
            {
                path: '/buscador-productos',
                component: resolve => require(['./views/productos/BuscadorProductos.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Producto',
                    permiso: ['modulo-productos'],
                    breadcrumb: '/buscador-productos',
                }
            },
            {
                path: '/decreto-1630/productos',
                component: resolve => require(['./views/decree_1630/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Decreto 1630',
                    permiso: ['modulo-decreto-1630'],
                    breadcrumb: '/decreto-1630/productos',
                }
            },
            {
                path: '/decreto-1630/registrar-importacion/:prod_product_id/:company_id',
                name: 'decreto-1630-crear',
                props: true,
                component: resolve => require(['./views/decree_1630/FormCreate.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Decreto 1630 - Productos',
                    permiso: ['modulo-decreto-1630'],
                    breadcrumb: '/decreto-1630/productos',
                }
            },
            {
                path: '/decreto-1630/componentes',
                component: resolve => require(['./views/decree_1630/components/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Decreto 1630  - Componentes',
                    permiso: ['modulo-decreto-1630'],
                    breadcrumb: '/decreto-1630/productos',
                }
            },
            {
                path: '/productos-proveedores',
                component: resolve => require(['./views/products_providers'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Productos proveedores',
                    permiso: ['productos-proveedores'],
                    breadcrumb: '/productos-proveedores',
                }
            },
            {
                path: '/identificacion-de-peligros/matriz-ram',
                component: resolve => require(['./views/identification_hazard/matrix_ram'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Identificación de peligros',
                    permiso: ['identificacion-de-peligros-matriz-ram'],
                    breadcrumb: '/identificacion-de-peligros/matriz-ram',
                }
            },
            {
                path: '/identificacion-de-peligros/matriz-hazid',
                component: resolve => require(['./views/identification_hazard/matrix_hazid'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Matriz HAZID',
                    permiso: ['identificacion-de-peligros-matriz-ram'],
                    breadcrumb: '/identificacion-de-peligros/matriz-hazid',
                }
            },
            {
                path: '/identificacion-de-peligros/matriz-hazid/:id/:company_id',
                component: resolve => require(['./views/identification_hazard/matrix_hazid/hazid'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Matriz HAZID',
                    permiso: ['identificacion-de-peligros-matriz-ram'],
                    breadcrumb: '/identificacion-de-peligros/matriz-hazid',
                }
            },
            {
                path: '/calculadora/productos',
                component: resolve => require(['./views/calculator/index'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Calculadora',
                    permiso: ['calculadora'],
                    breadcrumb: '/calculadora/productos',
                }
            },
            {
                path: '/calculadora/producto/:product_id/:company_id',
                component: resolve => require(['./views/calculator/form/index'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Calculadora',
                    permiso: ['calculadora'],
                    breadcrumb: '/calculadora/producto',
                }
            },
            {
                path: '/calculadora/producto/:product_id/:company_id/:view',
                component: resolve => require(['./views/calculator/form/index'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Calculadora',
                    permiso: ['calculadora'],
                    breadcrumb: '/calculadora/producto',
                }
            },
            {
                path: '/productos/:id',
                component: resolve => require(['./views/productos/Main.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Productos',
                    permiso: ['visualizar-productos'],
                    breadcrumb: `/productos/ver`
                }
            },
            {
                path: '/productos-crear',
                component: resolve => require(['./views/productos/Main.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Productos',
                    permiso: ['crear-productos'],
                    breadcrumb: '/productos/crear'
                }
            },
            {
                path: '/banners',
                component: resolve => require(['./views/banners'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Banners',
                    permiso: ['modulo-banners'],
                    breadcrumb: '/banners'
                }
            },
            {
                path: '/rotulo-un/:id',
                component: resolve => require(['./views/productos/sistemasclasificacion/rotulo.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Naciones Unidas',
                    permiso: ['visualizar-productos', 'administracion-historicos'],
                    breadcrumb: '/productos/crear'
                }
            },
            {
                path: '/productos_et/:id_producto/:id_empresa',
                component: resolve => require(['./views/productos_et/Main.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Productos',
                    permiso: ['visualizar-buscador-productos-disene-etiquetas'],
                    breadcrumb: `/productos_et/ver`
                }
            },
            {
                path: '/productos_et/crear/:id_empresa',
                component: resolve => require(['./views/productos_et/Main.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Productos',
                    permiso: ['crear-productos-disene-etiquetas'],
                    breadcrumb: `/productos_et/crear`
                }
            },
            {
                path: '/ordenes-empresas',
                component: resolve => require(['./views/productos_et/ordenes/Main.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Ordenes',
                    permiso: ['visualizar-ordenes-disene-etiquetas'],
                    breadcrumb: `/productos_et/ver`
                }
            },
            {
                path: '/productos-et-crear',
                name: 'productos-et-crear',
                component: resolve => require(['./views/productos_et/paso_a_paso/Main'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Crear Producto',
                    permiso: ['visualizar-buscador-productos-disene-etiquetas'],
                    breadcrumb: '/productos-et/crear'
                }
            },
            {
                path: '/buscador-productos-et',
                name: 'buscador-productos-et',
                component: resolve => require(['./views/productos_et/productos/Main'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Producto',
                    permiso: ['visualizar-buscador-productos-disene-etiquetas'],
                    breadcrumb: '/productos/'
                }
            },
            {
                path: '/productos-et/:id/:companyId/detalle',
                name: 'detalle-producto-et',
                component: resolve => require(['./views/productos_et/productos/details/Main'], resolve),
                props: true,
                meta: {
                    autenticado: true,
                    title: 'Producto',
                    permiso: ['visualizar-buscador-productos-disene-etiquetas'],
                    breadcrumb: '/productos/detalle'
                }
            },
            {
                path: '/reportes/inventario',
                component: resolve => require(['./views/reportes/Inventario.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Inventario',
                    permiso: ['modulo-inventario-productos'],
                    breadcrumb: '/reportes/inventario',
                },
            },
            {
                path: '/reportes/registro-accesos',
                component: resolve => require(['./views/reportes/registrosAccesos/Main.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Registro Accesos',
                    permiso: ['modulo-reporte-control-accesos'],
                    breadcrumb: '/reportes/registro-accesos',
                },
            },
            {
                path: '/reportes/tiempo-de-conexion',
                component: resolve => require(['./views/reportes/tiempoConexion/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Tiempo de conexión',
                    permiso: ['superadmin'],
                    breadcrumb: '/reportes/tiempo-de-conexion',
                },
            },
            {
                path: '/reportes/licencias',
                component: resolve => require(['./views/reportes/licencias/index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Reporte de licenciamiento',
                    permiso: ['modulo-reporte-licencias'],
                    breadcrumb: '/reportes/licencias',
                },
            },
            // Reportes - Señalización de tanques
            {
                path: '/reports/signaling-of-tanks',
                component: resolve => require(['./views/reportes/signalingOfTanks/index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Señalización de tanques',
                    permiso: ['reporte-modulo-tanques'],
                    breadcrumb: '/reports/signaling-of-tanks',
                },
            },
            /**
             * CONFIGURACIÓN DE AUDITORIA
             * Tipos de seguimiento
             */
            {
                path: '/tipo-seguimiento',
                component: resolve => require(['./views/configuracion_auditoria/tipo_seguimiento/lista-tipo-seguimiento.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Diseño de listas de chequeo - Tipos de seguimiento',
                    permiso: [
                        'modulo-diseno-listas-chequeo-tipos-seguimiento'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/crear/tipo-seguimiento',
                component: resolve => require(['./views/configuracion_auditoria/tipo_seguimiento/formulario-tipo-seguimiento.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Diseño de listas de chequeo - Crear tipo de seguimiento',
                    permiso: [
                        'modulo-diseno-listas-chequeo-tipos-seguimiento'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/editar/tipo-seguimiento/:id',
                component: resolve => require(['./views/configuracion_auditoria/tipo_seguimiento/formulario-tipo-seguimiento.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Diseño de listas de chequeo - Editar tipo de seguimiento',
                    permiso: [
                        'modulo-diseno-listas-chequeo-tipos-seguimiento'
                    ],
                    breadcrumb: ``
                }
            },
            /**
             * Items
             */
            {
                path: '/items',
                component: resolve => require(['./views/configuracion_auditoria/item/lista-item.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Diseño de listas de chequeo - Items',
                    permiso: [
                        'modulo-diseno-listas-chequeo-items'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/crear/item',
                component: resolve => require(['./views/configuracion_auditoria/item/formulario-item.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Diseño de listas de chequeo - Crear item',
                    permiso: [
                        'modulo-diseno-listas-chequeo-items'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/editar/item/:id',
                component: resolve => require(['./views/configuracion_auditoria/item/formulario-item.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Diseño de listas de chequeo - Editar item',
                    permiso: [
                        'modulo-diseno-listas-chequeo-items'
                    ],
                    breadcrumb: ``
                }
            },
            /**
             * Tipos de listas de chequeo
             */
            {
                path: '/tipo-lista-chequeo',
                component: resolve => require(['./views/configuracion_auditoria/tipo_lista_chequeo/lista-tipo-lista-chequeo.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Diseño de listas de chequeo - Tipos de listas de chequeo',
                    permiso: [
                        'modulo-diseno-listas-chequeo-tipos-listas-chequeo'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/crear/tipo-lista-chequeo',
                component: resolve => require(['./views/configuracion_auditoria/tipo_lista_chequeo/formulario.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Diseño de listas de chequeo - Crear tipos de lista de chequeo',
                    permiso: [
                        'modulo-diseno-listas-chequeo-tipos-listas-chequeo'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/editar/tipo-lista-chequeo/:id',
                component: resolve => require(['./views/configuracion_auditoria/tipo_lista_chequeo/formulario.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Diseño de listas de chequeo - Editar tipos de lista de chequeo',
                    permiso: [
                        'modulo-diseno-listas-chequeo-tipos-listas-chequeo'
                    ],
                    breadcrumb: ``
                }
            },
            /**
             * PLANEACIÓN DE AUDITORIA
             */
            {
                path: '/planeacion-auditoria',
                component: resolve => require(['./views/planeacion_auditoria'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Hallazgos - Preinspecciones',
                    permiso: [
                        'modulo-preinspecciones-hallazgos'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/planeacion-auditoria/crear',
                component: resolve => require(['./views/planeacion_auditoria/formulario.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Hallazgos - Crear preinspección',
                    permiso: [
                        'modulo-preinspecciones-hallazgos'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/planeacion-auditoria/editar/:id_planeacion/:id_empresa',
                component: resolve => require(['./views/planeacion_auditoria/formulario.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Hallazgos - Editar preinspección',
                    permiso: [
                        'modulo-preinspecciones-hallazgos'
                    ],
                    breadcrumb: ``
                }
            },
            /**
             * HALLAZGOS AUDITORIA
             */
            {
                path: '/listas-chequeo',
                component: resolve => require(['./views/hallazgos_auditoria'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Hallazgos - Inspecciones',
                    permiso: [
                        'inspecciones-hallazgos'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/estadisticas/:id_empresa/:id_tipo_seguimiento',
                component: resolve => require(['./views/hallazgos_auditoria/estadisticas'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Estadísticas',
                    permiso: [
                        'inspecciones-hallazgos'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/registrar-hallazgo',
                component: resolve => require(['./views/hallazgos_auditoria/registro-hallazgo.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Hallazgos - Crear inspección',
                    permiso: [
                        'modulo-inspecciones-hallazgos'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/editar-hallazgo/:id_lista/:id_empresa',
                component: resolve => require(['./views/hallazgos_auditoria/registro-hallazgo.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Hallazgos - Editar inspección',
                    permiso: [
                        'modulo-inspecciones-hallazgos'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/seguimiento-general',
                component: resolve => require(['./views/general_monitoring/List/Main'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Seguimiento',
                    permiso: [
                        'modulo-seguimiento-general'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/seguimiento-general/crear',
                component: resolve => require(['./views/general_monitoring/Create/Index'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Seguimiento general',
                    permiso: [
                        'administracion-modulo-seguimiento'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/seguimiento-general/:id/:company_id/detalle',
                props: true,
                component: resolve => require(['./views/general_monitoring/Details/Index'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Seguimiento general - Detalle',
                    permiso: [
                        'modulo-seguimiento-general'
                    ]
                }
            },
            {
                path: '/lista-hallazgos/:id_lista/:id_empresa',
                component: resolve => require(['./views/seguimiento_hallazgos/hallazgos.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Hallazgos - Crear seguimiento de inspección',
                    permiso: [
                        'modulo-seguimiento-inspecciones-hallazgos'
                    ],
                    breadcrumb: ``
                }
            },
            {
                path: '/tarjeta-emergencia/:idp',
                component: resolve => require(['./views/productos/tarjetasEmergencia/tarjeta-emergencia.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Tarjeta de Emergencia',
                    permiso: ['administracion-tarjetas-emergencia-producto', 'visualizar-tarjetas-emergencias-productos'],
                    breadcrumb: ``
                }
            },
            /**
             * CAS
             */
            {
                path: '/cas/crear',
                component: resolve => require(['./views/productos/cas/nuevoCas/Crear.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Carga Componentes CAS',
                    permiso: [
                        'superadmin',
                        'admin',
                        'modulo-cas-crear'
                    ],
                }
            },
            {
                path: '/cas/parametrizacion',
                component: resolve => require(['./views/productos/cas/nuevoCas/Parametrizacion.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Peligros CAS',
                    permiso: [
                        'superadmin',
                        'admin',
                        'modulo-cas-parametrizacion'
                    ],
                }
            },
            {
                path: '/cas/peligros/:id',
                component: resolve => require(['./views/productos/cas/nuevoCas/DangerViewDetails.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Peligro CAS',
                    title: 'Parametrizacion CAS',
                    permiso: [
                        'superadmin',
                        'admin',
                        'modulo-cas-parametrizacion'
                    ],
                }
            },
            {
                path: '/cas/crear-parametrizacion/:id?/:label?/:tagline?',
                component: resolve => require(['./views/productos/cas/nuevoCas/ParametrizacionCrear.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Crear Parametrizacion CAS',
                    permiso: [
                        'superadmin',
                        'admin',
                        'modulo-cas-parametrizacion'
                    ],
                }
            },
            {
                path: '/cas/componentes',
                component: resolve => require(['./views/productos/cas/nuevoCas/Componente.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Componentes',
                    permiso: [
                        'superadmin',
                        'admin',
                        'modulo-cas-componentes'
                    ],
                }
            },
            {
                path: '/cas/crear-componente/:component_id?',
                component: resolve => require(['./views/productos/cas/nuevoCas/ComponenteCrear.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Crear Componente',
                    permiso: [
                        'superadmin',
                        'admin',
                        'modulo-cas-componentes'
                    ],
                }
            },
            {
                path: '/cas/familias/',
                component: resolve => require(['./views/productos/cas/nuevoCas/families/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Familias',
                    permiso: [
                        'superadmin',
                        'admin',
                        'modulo-familia-cas'
                    ],
                }
            },
            {
                path: '/documentos',
                component: resolve => require(['./views/empresa/documentos/Main.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Documentos',
                    permiso: ['modulo-documentos'],
                    breadcrumb: ``
                }
            },
            /* {
                path: '/ubicaciones',
                component: resolve => require(['./views/empresa/ubicaciones'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Documentos',
                    permiso: ['adm_empresas/ubicacion'],
                    breadcrumb: ``
                }
            }, */
            {
                path: '/administracion',
                component: resolve => require(['./views/administracion/Main.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Administracion',
                    permiso: ['superadmin'],
                    breadcrumb: ``
                }
            },
            {
                path: '/form-builder',
                component: resolve => require(['./views/form_builder/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'List Form Builder',
                    permiso: ['superadmin', 'crear-formulario'],
                },
            },
            {
                path: '/form-builder/form/:id?',
                component: resolve => require(['./views/form_builder/FormBuilder.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Form Builder',
                    permiso: ['superadmin', 'editar-formulario'],
                    breadcrumb: ``
                },
            },
            {
                path: '/matriz-compatibilidad/almacenamiento-ingenieros',
                component: resolve => require(['./views/matrizCompatibilidad/almacenamiento_ingenieros/matriz-transporte.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Matriz de Compatibilidad',
                    permiso: ['modulo-matriz-compatibilidad-almacenamiento-ingenieros'],
                    breadcrumb: ``
                }
            },
            {
                path: '/matriz-compatibilidad/transporte',
                component: resolve => require(['./views/matrizCompatibilidad/transporte/matriz-transporte.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Matriz de Compatibilidad',
                    permiso: ['modulo-matriz-compatibilidad-transporte'],
                    breadcrumb: ``
                }
            },
            {
                path: '/matriz-compatibilidad/almacenamiento',
                component: resolve => require(['./views/matrizCompatibilidad/almacenamiento/index.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Matriz de Compatibilidad',
                    permiso: ['modulo-matriz-compatibilidad-almacenamiento'],
                    breadcrumb: ``
                }
            },
            {
                path: '/matriz-compatibilidad/almacenamiento/formulario/:id?/:id_empresa?',
                component: resolve => require(['./views/matrizCompatibilidad/almacenamiento/formulario.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Matriz de Compatibilidad',
                    permiso: ['modulo-matriz-compatibilidad-almacenamiento'],
                    breadcrumb: ``
                }
            },
            {
                path: '/matriz-compatibilidad/almacenamiento/crear',
                component: resolve => require(['./views/matrizCompatibilidad/matriz-paso-a-paso.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Matriz de Compatibilidad - Crear',
                    permiso: ['modulo-matriz-compatibilidad-almacenamiento-ingenieros'],
                    breadcrumb: ``
                }
            },
            {
                path: '/matriz-compatibilidad/transporte/crear',
                component: resolve => require(['./views/matrizCompatibilidad/matriz-paso-a-paso.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Matriz de Compatibilidad - Crear',
                    permiso: ['modulo-matriz-compatibilidad-transporte'],
                    breadcrumb: ``
                }
            },
            {
                path: '/matriz-compatibilidad/approve',
                component: resolve => require(['./views/matrizCompatibilidad/approveMatrix/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Auditar matriz de compatibilidad',
                    permiso: ['modulo-matriz-compatibilidad-auditar']
                }
            },
            {
                path: '/matriz-compatibilidad/administracion',
                component: resolve => require(['./views/matrizCompatibilidad/administrador/Main.vue'], resolve),
                meta: {
                    autenticado: true,
                    name: 'Matriz de Compatibilidad',
                    permiso: ['modulo-matriz-compatibilidad-administrador']
                }
            },
            {
                path: '/empresas/fds/:id',
                component: resolve => require(['./views/fds'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Empresa',
                    permiso: ['modulo-empresas'],
                    breadcrumb: '/empresas'
                }
            },
            {
                path: '/fds/administrador/datos',
                component: resolve => require(['./views/fds/AdmDatos.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Administración de datos',
                    permiso: ['fds-admin-datos'],
                    breadcrumb: '/'
                }
            },
            {
                path: '/fds/listar',
                component: resolve => require(['./views/fds/productos/Listar.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Diseño de FDS',
                    permiso: ['fds-diseno-fds'],
                    breadcrumb: '/'
                }
            },
            {
                path: '/fds/productos-crear',
                component: resolve => require(['./views/fds/productos/Formulario.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Formulario de creación de FDS',
                    permiso: ['fds-crear'],
                    breadcrumb: '/'
                }
            },
            {
                path: '/fds/productos/:id_fds_producto',
                component: resolve => require(['./views/fds/productos/Formulario.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Formulario de edición de FDS',
                    permiso: ['fds-editar'],
                    breadcrumb: '/'
                }
            },
            {
                path: '/inventory/:active?',
                component: resolve => require(['./views/inventory/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Inventario',
                    permiso: ['configuracion-inventario'],
                    breadcrumb: ``
                }
            },
            {
                path: '/inventories/create-section',
                component: resolve => require(['./views/inventory/Sections/Register.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Crear sección de inventario',
                    permiso: ['configuracion-inventario'],
                    breadcrumb: ``
                }
            },
            {
                path: '/inventories/update-section/:id?',
                component: resolve => require(['./views/inventory/Sections/Update.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Actualizar sección de inventario',
                    permiso: ['configuracion-inventario'],
                    breadcrumb: ``
                }
            },
            {
                path: '/inventories/create-column',
                component: resolve => require(['./views/inventory/Colums/Register.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Crear columna de inventario',
                    permiso: ['configuracion-inventario'],
                    breadcrumb: ``
                }
            },
            {
                path: '/inventories/update-column/:id?',
                component: resolve => require(['./views/inventory/Colums/Update.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Actualizar columna de inventario',
                    permiso: ['configuracion-inventario'],
                    breadcrumb: ``
                }
            },
            {
                path: '/generate-report-inventory',
                component: resolve => require(['./views/inventory/Reports/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Generar reporte de inventario',
                    permiso: ['generar-reporte-inventario','generar-reporte-inventario-contratistas'],
                    breadcrumb: ``
                }
            },
            {
                path: '/high-accidents',
                component: resolve => require(['./views/accidents_high/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Listado de accidentes mayores',
                    permiso: ['listar-accidente-mayor'],
                    breadcrumb: ``
                }
            },
            {
                path: '/high-accidents/:id/location/:location_id',
                component: resolve => require(['./views/accidents_high/AddProduct.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Detalle del accidente mayor',
                    permiso: ['ver-accidente-mayor'],
                    breadcrumb: ``
                }
            },
            {
                path: '/high-accidents/:id/asign-product/:location_id/:company_id',
                name: 'accidents-high-assign-product',
                props: true,
                component: resolve => require(['./views/accidents_high/ViewAddProduct.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Asignar producto',
                    permiso: ['ver-accidente-mayor'],
                    breadcrumb: ``
                }
            },
            {
                path: '/high-accidents/:id/location-not-ppam/:location_id',
                component: resolve => require(['./views/accidents_high/ProductsNotPpam.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Detalle del accidente mayor',
                    permiso: ['ver-accidente-mayor'],
                    breadcrumb: ``
                }
            },
            {
                path: '/high-accidents/:id/location-products-inactives/:location_id',
                component: resolve => require(['./views/accidents_high/PrductsInactives.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Detalle del accidente mayor',
                    permiso: ['ver-accidente-mayor'],
                    breadcrumb: ``
                }
            },
            {
                path: '/high-accidents-summary/:id',
                component: resolve => require(['./views/accidents_high/Summary.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Detalle del accidente mayor',
                    permiso: ['resumen-accidente-mayor'],
                    breadcrumb: ``
                }
            },
            {
                path: '/high-accidents-admin',
                component: resolve => require(['./views/accidents_high/Admin/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Administración de accidentes mayores',
                    permiso: ['modulo-administrador-accidentes-mayores'],
                    breadcrumb: ``
                }
            },
            {
                path: '/high-accidents-admin-section/:id',
                component: resolve => require(['./views/accidents_high/Admin/Section.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Detalle del accidente mayor',
                    permiso: ['modulo-administrador-accidentes-mayores'],
                    breadcrumb: ``
                }
            },
            {
                path: '/high-accidents-admin-sub-section/:id',
                component: resolve => require(['./views/accidents_high/Admin/SubSection.vue'], resolve),
                name: 'AccidentsHighAdminSubSection',
                meta: {
                    autenticado: true,
                    title: 'Detalle del accidente mayor',
                    permiso: ['modulo-administrador-accidentes-mayores'],
                    breadcrumb: ``
                }
            },
            {
                path: '/high-accidents-admin-table/:id',
                component: resolve => require(['./views/accidents_high/Admin/Table.vue'], resolve),
                name: 'AccidentsHighAdminTable',
                meta: {
                    autenticado: true,
                    title: 'Detalle del accidente mayor',
                    permiso: ['modulo-administrador-accidentes-mayores'],
                    breadcrumb: ``
                }
            },
            {
                path: '/seguridad-de-procesos/sistema-de-gestion-pepam',
                name: 'seguridad-de-procesos',
                props: true,
                component: resolve => require(['./views/process_security/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Seguridad de procesos',
                    permiso: ['superadmin','administracion-procesos-seguridad'],
                    breadcrumb: ``
                }
            },
            {
                path: '/seguridad-de-procesos/cumplimiento-general',
                name: 'sp-cumplimiento-general',
                props: true,
                component: resolve => require(['./views/process_security/OverallGeneral/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Cumplimiento general',
                    permiso: ['superadmin','administracion-procesos-seguridad'],
                    breadcrumb: ``
                }
            },
            {
                path: '/seguridad-de-procesos/:id/:company_id/editar',
                props: true,
                component: resolve => require(['./views/process_security/FormUpdate.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Seguridad de procesos',
                    permiso: ['superadmin','administracion-procesos-seguridad'],
                    breadcrumb: ``
                }
            },
            {
                path: '/seguridad-de-procesos/:id/:company_id/editar/:type',
                props: true,
                component: resolve => require(['./views/process_security/PreventionPolicy/FormUpdate'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Seguridad de procesos',
                    permiso: ['superadmin','administracion-procesos-seguridad'],
                    breadcrumb: ``
                }
            },
            {
                path: '/seguridad-de-procesos/crear',
                props: true,
                component: resolve => require(['./views/process_security/FormSaveTabs.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Seguridad de procesos',
                    permiso: ['superadmin','administracion-procesos-seguridad'],
                    breadcrumb: ``
                }
            },
            {
                path: '/seguridad-de-procesos/parametros',
                props: true,
                component: resolve => require(['./views/process_security/Parametric/Index'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Seguridad de procesos',
                    permiso: ['superadmin','administracion-procesos-seguridad'],
                    breadcrumb: ``
                }
            },
            {
                path :'/app-banners',
                props: true,
                component: resolve => require(['./views/app_banners/index'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Banners del sistema',
                    permiso: ['modulo-banners-app'],
                    breadcrumb: ``
                }
            },
            {
                path: '/history/update-pq',
                props: true,
                component: resolve => require(['./views/history/updatePQ/Index'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Actualizaciones PQ',
                    permiso: ['superadmin', 'modulo-historico-actualizacion-pq'],
                    breadcrumb: ``
                }
            },
            {
                path: '/history/assign-pq',
                props: true,
                component: resolve => require(['./views/history/assignPQ/Index'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Asignaciones PQ',
                    permiso: ['superadmin', 'modulo-historico-asignacion-pq'],
                    breadcrumb: ``
                }
            },
            {
                path: '/findings-config',
                component: resolve => require(['./views/findings/Config.vue'], resolve),
                name: "findings-config",
                meta: {
                    autenticado: true,
                    title: 'Configuración de hallazgos',
                    breadcrumb: ``,
                    permiso: ["modulo-configuracion-de-hallazgos"]
                }
            },
            {
                path: '/findings',
                component: resolve => require(['./views/findings/Index.vue'], resolve),
                name: "findings",
                meta: {
                    autenticado: true,
                    title: 'Hallazgos',
                    breadcrumb: ``,
                    permiso: ["ver-modulo-reporte-hallazgos"]
                }
            },
            {
                path: '/findings/detail/:company_id/:id',
                component: resolve => require(['./views/findings/Detail.vue'], resolve),
                name: "findings-detail",
                meta: {
                    autenticado: true,
                    title: 'Detalle de hallazgo',
                    breadcrumb: ``,
                    permiso: ["ver-modulo-reporte-hallazgos"]
                }
            },
            {
                path: '/sga/configs',
                component: resolve => require(['./views/sga/configurations/Index.vue'], resolve),
                name: 'sga-configs',
                meta: {
                    autenticado: true,
                    title: 'Configuraciones SGA',
                    breadcrumb: ``,
                    permiso: ['superadmin', 'modulo-sga-configuraciones']
                }
            },
            {
                path: '/videos/administracion',
                component: resolve => require(['./views/videos/Admin/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Video',
                    permiso: ['modulo-admin-video','superadmin'],
                    breadcrumb: '/videos/administracion'
                }
            },
            {
                path: '/videos/categorias',
                component: resolve => require(['./views/videos/Category/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Video',
                    permiso: ['modulo-admin-video','superadmin'],
                    breadcrumb: '/videos/administracion'
                }
            },
            {
                path: '/videos/empresa',
                component: resolve => require(['./views/videos/Company/Index.vue'], resolve),
                meta: {
                    autenticado: true,
                    title: 'Video',
                    permiso: ['modulo-empresa-video'],
                    breadcrumb: '/videos/empresa'
                }
            }
        ]
    },
    {
        path: '/login',
        component: resolve => require(['./views/login/Login.vue'], resolve),
        meta: {
            autenticado: false,
            title: 'Login',
            breadcrumb: ``,
            permiso: ['login']
        }
    },
    // Azure config routes
    {
        path: '/login.microsoftonline.com:nitCompany',
        component: resolve => require(['./views/auth_azure/RedirectToLogin.vue'], resolve),
        meta: {
            autenticado: false,
            title: 'Redirect to login Microsoft online',
            breadcrumb: ``,
            permiso: ['login']
        }
    },
    {
        path: '/azure-auth.microsoftonline.com',
        component: resolve => require(['./views/auth_azure/LoggingIn.vue'], resolve),
        meta: {
            autenticado: false,
            title: 'Logging in Microsoft online',
            breadcrumb: ``,
            permiso: ['login'],
        }
    },
    {
        path: '/recuperar-contrasena',
        component: resolve => require(['./views/login/RecuperarContrasena.vue'], resolve),
        meta: {
            autenticado: false,
            title: 'Recupera Contraseña',
            breadcrumb: ``,
            permiso: ['login']
        }
    },
    {
        path: '/cambiar-contrasena',
        component: resolve => require(['./views/login/CambiarContrasena.vue'], resolve),
        meta: {
            autenticado: true,
            title: 'Cambiar Contraseña',
            breadcrumb: ``,
            permiso: ['login']
        }
    },
    {
        path: '/cambiar-contrasena-olvidada',
        component: resolve => require(['./views/login/CambiarContrasenaOlvidada.vue'], resolve),
        meta: {
            autenticado: false,
            title: 'Cambiar Contraseña olvidada',
            breadcrumb: ``,
            permiso: ['login']
        }
    },
    {
        path: '/logout',
        component: resolve => require(['./views/Logout.vue'], resolve),
        meta: {
            autenticado: false,
            title: 'Logout',
            breadcrumb: ``,
            permiso: ['login']
        }
    },
    // Ver detalles del producto con QR
    {
        path: '/visualizer/product-qr/:hashKey',
        component: resolve => require(['./views/productos/visualizer/Index.vue'], resolve),
        name: "visualizer-product-qr",
        meta: {
            autenticado: false,
            isVisualizerProduct: true,
            title: 'Ver detalles del producto con código QR',
            breadcrumb: ``,
            permiso: ['login']
        }
    },
    // Interceptor que se encarga de verificar el Code de la url corta para redireccionar a la url real
    {
        path: '/short-urls/:code',
        component: resolve => require(['./views/urlsShorter/Interceptor.vue'], resolve),
        name: "short-urls-interceptor",
        meta: {
            autenticado: false,
            isInterceptorShortUrls: true,
            title: 'Interceptor que se encarga de verificar el Key de la url corta para redireccionar a la url real',
            breadcrumb: ``,
            permiso: ['login']
        }
    }
];

export default routes
    .concat(routes_workers)
    .concat(routes_ari);
